import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import CotizaPlusApp from './modules/cotizaplus/App';

// Context Providers
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';

// Auth Pages (reusing from CotizaPlus for now)
import Login from './modules/cotizaplus/pages/auth/Login';
import Register from './modules/cotizaplus/pages/auth/Register';
import PaymentCheckout from './modules/cotizaplus/pages/auth/PaymentCheckout';
import VerifyEmail from './modules/cotizaplus/pages/auth/VerifyEmail';
import RequestPasswordReset from './modules/cotizaplus/pages/auth/RequestPasswordReset';
import ResetPasswordConfirm from './modules/cotizaplus/pages/auth/ResetPasswordConfirm';
import ForcePasswordChange from './modules/cotizaplus/pages/auth/ForcePasswordChange';
import ProtectedRoute from './components/ProtectedRoute';

// Public/Shell Pages
import Landing from './pages/Landing';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import PublicQuotation from './modules/cotizaplus/pages/public/PublicQuotation';
import PublicQuotationReview from './modules/cotizaplus/pages/public/PublicQuotationReview';
import PostRegistration from './pages/PostRegistration';

// Global Admin Pages
import Settings from './pages/admin/Settings';
import Employees from './pages/admin/Employees';
import RequestsPanel from './pages/admin/RequestsPanel';
import GoogleCallback from './pages/auth/GoogleCallback';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <Routes>
            {/* Global Auth Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/payment/checkout/:pagoId" element={<PaymentCheckout />} />
            <Route path="/verificar-cuenta" element={<VerifyEmail />} />
            <Route path="/request-password-reset" element={<RequestPasswordReset />} />
            <Route path="/reset-password-confirm" element={<ResetPasswordConfirm />} />

            {/* Cambio de Contraseña Obligatorio (root level) */}
            <Route
              path="/change-password"
              element={
                <ProtectedRoute allowPasswordChange={true}>
                  <ForcePasswordChange />
                </ProtectedRoute>
              }
            />

            {/* Rutas Públicas (sin autenticación) */}
            <Route path="/autoatencion/:slug" element={<PublicQuotation />} />
            <Route path="/cotizacion/:uuid" element={<PublicQuotationReview />} />

            {/* Main Shell Layout (Public & Authed shared) */}
            <Route element={<MainLayout />}>
              {/* Landing Page / App Launcher (Handles auth logic internally) */}
              <Route path="/" element={<Landing />} />
              <Route path="/registro-exitoso" element={<PostRegistration />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/contacto" element={<Contact />} />

              {/* Protected Global Modules */}
              <Route path="/app/configuracion" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="/app/empleados" element={<ProtectedRoute><Employees /></ProtectedRoute>} />
              <Route path="/app/solicitudes" element={<ProtectedRoute><RequestsPanel /></ProtectedRoute>} />
              <Route path="/app/google-callback" element={<ProtectedRoute><GoogleCallback /></ProtectedRoute>} />

              {/* Protected Module: CotizaPlus */}
              <Route path="/app/cotizaplus/*" element={<ProtectedRoute><CotizaPlusApp /></ProtectedRoute>} />

              {/* Protected Future Modules */}
              <Route path="/app/crm" element={<ProtectedRoute><h2 className="text-center mt-5">CRMPlus: Próximamente</h2></ProtectedRoute>} />
              <Route path="/app/inventario" element={<ProtectedRoute><h2 className="text-center mt-5">InventarioPlus: Próximamente</h2></ProtectedRoute>} />
            </Route>

            {/* 404 Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
